import { deleteAssessment, getAssessment } from '@/actions/room';
import {
  Button,
  Collapse,
  Dropdown,
  Menu,
  Modal,
  Pagination,
  Popconfirm,
  Skeleton,
} from 'antd';
import moment from 'moment';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AssessmentFileList from '../FileList';
import AnswerForm from '../answers/AnswerForm';
import EditAssessment from './EditAssessment';
import useWidth from '@/helpers/widthUtil';
const { Panel } = Collapse;

const AssessmentQuestions = ({
  data,
  roomSlug,
  meta,
  isStaff,
  roomId,
  courseSlug,
}) => {
  const { isMobile } = useWidth();
  const dispatch = useDispatch();
  const router = useRouter();

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [query, setQuery] = useState({
    page: 1,
    per_page: 10,
  });
  const [visible, setVisible] = useState(false);
  const [submissionVisible, setSubmissionVisible] = useState(false);
  const [assessmentId, setAssessmentId] = useState(null);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    dispatch(getAssessment(roomSlug, query));
  }, [JSON.stringify([query.page, query.per_page])]);

  const PostMenu = ({ editValue }) => {
    return (
      <Menu className="p-2" style={{ borderRadius: '8px' }}>
        <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
          <a onClick={() => handleOpen(editValue)}>
            <div className="dropdown-media d-flex align-items-center px-2">
              <i className="fas fa-edit fa-lg text-muted mr-3"></i>
              <span className="mr-3">Edit</span>
            </div>
          </a>
        </Menu.Item>
        <Menu.Item className="pr-5 p-2" style={{ borderRadius: '8px' }}>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(editValue?.id)}
          >
            <a title="Delete Notice " className=" d-flex align-items-center px-2">
              <i className="fas fa-trash fa-lg text-muted mr-3"></i>
              <span>Delete</span>
            </a>
          </Popconfirm>
        </Menu.Item>
      </Menu>
    );
  };

  const header = (each) => (
    <>
      <div className="d-flex align-items-center justify-content-between ">
        <div className={`${isMobile && 'd-flex flex-column gap-1'}`}>
          <span className="float-left">
            <span style={{ fontSize: '18px' }}>
              <img src="/images/40.svg" height="30" width="30" />
            </span>
            &nbsp;
            <span className="assessment-title ml-2">{each?.title}</span>
          </span>
          {isMobile && (
            <div className="light-text text-black">
              <div style={{ textAlign: 'left' }}> {each?.subject?.name}</div>
              <div>
                {each?.due_date ? (
                  <> Due: {moment(each?.due_date).format('YYYY-MM-DD')}</>
                ) : (
                  'No due date'
                )}
              </div>
            </div>
          )}
        </div>
        <div className="d-flex align-items-center gap-4">
          {!isMobile && (
            <div className="light-text text-black">
              <div style={{ textAlign: 'right' }}> {each?.subject?.name}</div>
              <div>
                {each?.due_date ? (
                  <> Due: {moment(each?.due_date).format('YYYY-MM-DD')}</>
                ) : (
                  'No due date'
                )}
              </div>
            </div>
          )}
          {isStaff && (
            <div
              className="d-flex list-action"
              style={{ height: 'fit-content' }}
              onClick={(e) => e.stopPropagation()}
            >
              <Dropdown
                overlay={<PostMenu editValue={each} />}
                placement="bottomLeft"
                className="dropdown-ml ml-auto"
                trigger={['click']}
                overlayStyle={{ minWidth: '160px' }}
              >
                <div>
                  <span className="badge bg-warning-light">
                    <i className="fas fa-ellipsis-h"></i>
                  </span>
                </div>
              </Dropdown>
            </div>
          )}

          {!isStaff && (
            <Button
              className="assignment-link ant-btn btn-primary"
              onClick={(e) => {
                e.stopPropagation();

                each?.is_submmited || each?.is_marked
                  ? router.push({
                      pathname: `/room/${roomSlug}/assessment/${each?.id}`,
                    })
                  : handleOpenSubmitModal(each);
              }}
            >
              {each?.is_marked
                ? 'View Result'
                : each?.is_submmited
                ? 'View Answer'
                : 'Submit'}
            </Button>
          )}
        </div>
      </div>
    </>
  );

  const { loading } = useSelector((state: any) => ({
    loading: state?.roomReducer?.assessment?.getAssessmentStatus,
  }));

  const handlePagination = (page, pageSize) => {
    setQuery({ ...query, page, per_page: pageSize });
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleSubmitCancel = () => {
    setSubmissionVisible(false);
  };

  const handleOpen = (data) => {
    setEditData(data);
    setVisible(true);
  };

  const handleDelete = (id) => {
    dispatch(deleteAssessment(id));
  };

  const handleOpenSubmitModal = (data) => {
    setAssessmentId(data?.id);
    setSubmissionVisible(true);
  };

  return (
    <>
      <Modal
        visible={submissionVisible}
        title="Submit Assessment"
        footer={null}
        onCancel={handleSubmitCancel}
        width={1000}
        maskClosable={false}
      >
        <AnswerForm
          assessmentSlug={assessmentId}
          handleCancel={handleSubmitCancel}
          query={query}
          roomSlug={roomSlug}
        />
      </Modal>

      <Modal
        visible={visible}
        title="Edit Assessment"
        footer={null}
        onCancel={handleCancel}
        width={1000}
        maskClosable={false}
        destroyOnClose
      >
        <EditAssessment
          roomSlug={roomSlug}
          roomId={roomId}
          courseSlug={courseSlug}
          handleCancel={handleCancel}
          data={editData}
        />
      </Modal>
      {!loading ? (
        data && data?.length !== 0 ? (
          data?.map((each, idx) => (
            <Collapse
              className="mb-3 assessment assessment--room__collapse"
              key={idx}
            >
              <Panel header={header(each)} key="1" showArrow>
                <div dangerouslySetInnerHTML={{ __html: each?.description }} />

                <br />
                <div>
                  <AssessmentFileList files={each?.files} loading={false} />
                </div>
                <div className="d-flex align-items-center justify-content-between ">
                  <div>
                    <i className="fas fa-chalkboard-teacher mr-1"></i>{' '}
                    {each?.created_by?.first_name +
                      ' ' +
                      each?.created_by?.last_name}
                  </div>
                  <Link
                    href={
                      isStaff
                        ? `/room/${roomSlug}/assessment/${each?.id}/dashboard`
                        : `/room/${roomSlug}/assessment/${each?.id}`
                    }
                  >
                    <a className="assignment-link ant-btn btn-primary">
                      {isStaff ? 'View Assignment' : 'More Details'}
                    </a>
                  </Link>
                </div>
              </Panel>
            </Collapse>
          ))
        ) : (
          ''
        )
      ) : (
        <>
          <br />
          <Skeleton active paragraph={{ rows: 8 }} />
        </>
      )}
      {data?.length !== 0 ? (
        <Pagination
          className="my-5 float-right"
          defaultCurrent={page}
          total={meta?.total}
          showSizeChanger
          onChange={handlePagination}
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
          defaultPageSize={perPage}
        />
      ) : (
        ''
      )}
    </>
  );
};
export default AssessmentQuestions;
